import { default as defaultShadows } from "@mui/material/styles/shadows.js";
export const createShadows = () => {
    return [
        // @ts-expect-error - MUI type definition is wrong
        ...defaultShadows,
    ];
};
//# sourceMappingURL=shadows.js.map